module.exports = __webpack_public_path__ + "img/Australia.2389fb31.png";